import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createMultiValueLabelStyle = ({
  fonts,
  colors,
  select,
}: ThemeType) => (baseCSS: CSSObject, {
  isDisabled,
}: {
  isDisabled: boolean;
}): CSSObject => ({
  ...fonts[select.MULTI_VALUE_LABEL_FONT],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  paddingTop: 3,
  paddingBottom: 3,
  paddingRight: 4,
  color: isDisabled
    ? colors[select.MULTI_VALUE_LABEL_COLOR_DISABLED]
    : colors[select.MULTI_VALUE_LABEL_COLOR],
});
